import { Link, useParams } from 'react-router-dom'
import deleteIcon from '../../assets/icons/generals/delete-2.svg'
import { useRequestProcessor } from '../../api/requestProcessor'
import { deleteSingleGalleryImage } from '../../api/galleries'
import { toast } from 'react-toastify'
import { domainName } from '../../constants/site'

const GalleryCard = ({ data, isDescripeDisable }) => {
    return (
        <Link to={"/admin/galleries/edit/" + data?.id} className="galleryCard" >
            <div className={`galleryCard__background !bg-gray-100
            `}
                style={{ background: "url(" + domainName + data?.workshop_cover?.file?.thumb + ")" }}
            >
            </div>
            {
                isDescripeDisable ?
                    <div className='absolute top-0 w-full h-full flex justify-center items-center 
                    opacity-0 hover:opacity-100 transition-all' >
                        <img src={deleteIcon} className='w-20 bg-white p-4 rounded-full cursor-pointer' alt="حذف عکس" />
                    </div>
                    :
                    <div className=" galleryCard__content">
                        {/* <p className="text-gray-100">Category</p> */}
                        <h3 className="galleryCard__heading font-bold !text-base">{data?.title}</h3>
                    </div>
            }
        </Link>
    )
}


export const GalleryCardView = ({ id,imageSrc, isNewGallery ,filterNewImage, handleRefetch }) => {
    const { gallery_id } = useParams()

    const { Mutate } = useRequestProcessor()

    const { mutate: mutateDelete } = Mutate(
        ["deleteSingleGalleryImage",id],
        deleteSingleGalleryImage,
        {
            onSuccess: (data) => {
                toast.success(data.message , {
                    autoClose: 2500,
                    progress: false,
                })
                handleRefetch()
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    return (
        <div className="galleryCard" >
            <div className={`galleryCard__background !bg-gray-100
        `}
                style={{ background: "url(" + domainName + imageSrc + ")" }}></div>

                <div className='absolute top-0 w-full h-full flex justify-center items-center 
                    opacity-0 hover:opacity-100 transition-all' >
                    <img src={deleteIcon} onClick={()=>{ isNewGallery ? filterNewImage(id) :  mutateDelete({id:gallery_id,data:{file_id :id}})}} className='w-20 bg-white p-4 rounded-full cursor-pointer' alt="حذف عکس" />
                </div>
        </div>
    )
}

export default GalleryCard